export default "__VITE_ASSET__Dhg2u3nP__"